import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ContentManagerService } from '../../services/content-manager.service';
import { EditorService } from '../../services/editor.service';

// const AlignStyle = Quill.import('attributors/style/align') as any;
// const ColorStyle = Quill.import('attributors/style/color') as any;

// Quill.register(AlignStyle, true);
// Quill.register(ColorStyle, true);

@Component({
  selector: 'app-inline-text-editor-component',
  templateUrl: './inline-text-editor-component.component.html',
  styleUrls: ['./inline-text-editor-component.component.scss'],
  standalone: false,
})
export class InlineTextEditorComponent implements OnInit, AfterViewInit {
  @Input() value!: HTMLElement | string;
  @Input() valueType: 'HTMLElement' | 'innerHTML';

  @Output() save = new EventEmitter<HTMLElement>();

  @Output() saveinnerHTML = new EventEmitter<string>();

  @Output() cancelModal = new EventEmitter<void>();

  @ViewChild('toolbar') toolbarRef!: ElementRef<HTMLDivElement>;

  @ViewChild('toolbar', { static: true, read: ElementRef })
  toolbarHost!: ElementRef<HTMLElement>;

  @ViewChild('quillRef', { static: false }) quillRef;

  content = '';

  /** =============  P R Z E S U W A N I E  ============== **/
  public dragging = false;

  atValues = [
    { id: 1, value: 'Fredrik Sundqvist', link: 'https://google.com' },
    { id: 2, value: 'Patrik Sjölin' },
  ];
  hashValues = [
    { id: 3, value: 'Fredrik Sundqvist 2' },
    { id: 4, value: 'Patrik Sjölin 2' },
  ];

  constructor(
    private contentManagerService: ContentManagerService,
    private editorService: EditorService
  ) {}

  ngOnInit(): void {
    if (this.valueType === 'HTMLElement' && this.value instanceof HTMLElement) {
      this.content = this.value.innerHTML;
    } else if (
      this.valueType === 'innerHTML' &&
      typeof this.value === 'string'
    ) {
      this.content = this.value;
    }
  }

  quillConfig = {
    formats: [
      // ← konieczne, gdy używasz StyleAttributor
      'align',
      'color',
      'bold',
      'italic',
      'underline',
      'header',
      'font',
      'list',
      'link',
    ],
    toolbar: {
      container: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ color: [] }],
        ['link'],
      ],
      handlers: {
        align: function (value) {
          this.quill.format('align', value);
        },
        color: function (value) {
          // quill dla koloru czarnego zwraca false
          if (value === false) {
            value = '#000000';
          }
          this.quill.format('color', value);
        },
      },
    },
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          handler: (range, context) => {
            console.log('enter');
            return true;
          },
        },
      },
    },
  };

  onSave() {
    if (this.valueType === 'HTMLElement' && this.value instanceof HTMLElement) {
      this.value.innerHTML = this.content.replace(/&nbsp;/g, ' ');
      this.save.emit(this.value);
      this.contentManagerService.processHtmlElement(this.value);
    } else if (
      this.valueType === 'innerHTML' &&
      typeof this.value === 'string'
    ) {
      this.content = this.value;
      this.value = this.content.replace(/&nbsp;/g, ' ');
      this.saveinnerHTML.emit(this.value);
    }
  }

  ngAfterViewInit() {
    const editor = this.quillRef?.quillEditor;
    if (editor) {
      editor.root.addEventListener('input', () => {
        editor.root.style.height = 'auto';
        editor.root.style.height = editor.root.scrollHeight + 'px';
      });
    }
  }

  onCancel() {
    this.cancelModal.emit();
  }

  autoResize() {
    const editor = this.quillRef?.quillEditor;
    if (editor) {
      editor.root.style.height = 'auto';
      editor.root.style.height = editor.root.scrollHeight + 'px';
    }
  }

  /** zamyka, gdy klik ‑ poza edytorem i paskiem */
  @HostListener('document:mousedown', ['$event'])
  closeWhenOutside(ev: MouseEvent): void {
    const target = ev.target as HTMLElement;
    const inToolbar = this.toolbarRef.nativeElement.contains(target);
    const inEditor = this.quillRef?.quillEditor?.root.contains(target);
    if (!(inToolbar || inEditor)) {
      this.onSave();
      this.cancelModal.emit();
    }
  }

  onEditorCreated() {
    const toolbarEl = this.toolbarHost.nativeElement.querySelector(
      '.ql-toolbar'
    ) as HTMLElement;

    this.reposition(toolbarEl);
    window.addEventListener('resize', () => this.reposition(toolbarEl));
  }

  reposition(toolbar: HTMLElement) {
    const gap = 8;
    const rect = toolbar.getBoundingClientRect();
    const overflow = rect.right - window.innerWidth;
    if (overflow > 0) {
      toolbar.style.left = -(overflow + gap) + 'px';
    }
  }
}
